import { Component, Input, OnInit, Self } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap, catchError } from 'rxjs/operators';
import { BATSCoreService } from 'src/app/services/batscore.service';
import { Building } from './building';

@Component({
  selector: 'bats-bldg-lookup',
  templateUrl: './bats-bldg-lookup.component.html',
  styleUrls: ['./bats-bldg-lookup.component.css']
})
export class BatsBldgLookupComponent implements ControlValueAccessor {
  value: any;
  searching = false;
  searchFailed = false;
  @Input() name: string;
  @Input() site: string;
  @Input() required = false;
  @Input() placeholder: string = '';
  @Input() disabled = false;
  @Input() label: string;
  @Input() help: string;
  @Input() icon: string;
  @Input() classes: string = "form-control";

  constructor(@Self() public NgControl: NgControl,
  private bats: BATSCoreService) {
    NgControl.valueAccessor = this;
   }


   onTouched: () => void = () => { };
   
   onChange: (_: any) => void = (_: any) => { };

   updateChanges() {
    this.onChange(this.value);
  }

  writeValue(value: any): void {
    this.value = value;
    this.updateChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  
  search = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(term =>
      this.searchSite(term).pipe(
        tap(() => this.searchFailed = false),
        catchError(() => {
          this.searchFailed = true;
          return of([]);
        }))
    )
  )

  searchSite(term: string) {
    if (term === '') return of([]);
    return this.bats
    .GetData('/cleryadmin/api/bldg', {srch: term}, '');
  }

  searchInputFormatter = (x: {BUILDING_AND_NAME : string }) => x.BUILDING_AND_NAME;
  handleSearchResults = (result: any)  => this.value = result as Building;
}
